// React
import { useHistory } from 'react-router-dom';
import React, { useEffect, useCallback, useState, useMemo } from 'react';

// Containers Injection
import { notifyError } from '../../containers/componentsInjection';
import { ReportsInjection } from '../../containers/reportsInjection';

// Yup validation
import * as Yup from 'yup';
import { useFormik } from 'formik';

// View
import { ProposalsForRenewalPage } from './view';

// Utils
import { useLoading } from '../../../../hook/useLoading';
import { createData } from '../../../../utils/createData';
import { APIClient } from '../../../../helpers/api_helper';
import { openPdfWithBase64 } from '../../../../utils/openPdfWithBase64';

export const ProposalsForRenewal = () => {
  const [departmentOptions, setDepartmentOptions] = useState([]);
  const [proposalStatusOptions, setProposalStatusOptions] = useState([]);

  const {
    sellers,
    getSellers,
    categoryPlans,
    organizations,
    getOrganizations,
    getCategoryPlans,
  } = ReportsInjection();

  const api = new APIClient();
  const history = useHistory();
  const { toggleLoading, setLoading } = useLoading();

  const getOptionsToDepartmentInput = useCallback(async (idOrganization) => {
    await api
      .get(`/register/unit/find-by-organization/${idOrganization}`)
      .then((options) => {
        setDepartmentOptions(createData(options));
      });
  }, []);

  const getProposalStatus = useCallback(async () => {
    await api.get('/proposal/get-status').then((status) => {
      setProposalStatusOptions(createData(status));
    });
  }, []);

  const resetDepartmentInput = () => {
    if (validation.values.departmentInput) {
      validation.handleChange({
        target: {
          name: 'departmentInput',
          value: {
            label: '',
            value: '',
          },
        },
      });
    }
  };

  const cadastralStatusOptions = useMemo(
    () => [
      {
        value: '1',
        label: 'Contratado',
      },
      {
        value: '2',
        label: 'Efetivo',
      },
      {
        value: '3',
        label: 'Aposentado',
      },
      {
        value: '4',
        label: 'Cancelado',
      },
      {
        value: '5',
        label: 'Inativo',
      },
      {
        value: 0,
        label: 'Outros',
      },
    ],
    []
  );

  const validation = useFormik({
    // enableReinitialize : use this flag when initial values needs to be changed
    enableReinitialize: true,

    initialValues: {
      periodStarts: '',
      periodEnds: '',
      sellerInput: {
        label: '',
        value: '',
      },
      categoryPlanInput: [],
      organizationInput: '',
      departmentInput: '',
      employeeSituationInput: [],
      proposalSituationInput: [],
    },
    validationSchema: Yup.object({
      periodStarts: Yup.string(),
      periodEnds: Yup.string(),
      sellerInput: Yup.object().shape({
        label: Yup.string(),
        value: Yup.string(),
      }),
      categoryPlanInput: Yup.array(),
      organizationInput: Yup.object().shape({
        label: Yup.string(),
        value: Yup.string(),
      }),
      departmentInput: Yup.object().shape({
        label: Yup.string(),
        value: Yup.string(),
      }),
      proposalSituationInput: Yup.array().nullable(),
      employeeSituationInput: Yup.array().nullable(),
    }),

    onSubmit: (values) => {
      let categoryPlansArray = values.categoryPlanInput.map((item) => {
        return item.value;
      });

      let proposalStatusArray = values.proposalSituationInput.map((item) => {
        return item.value;
      });

      let cadastralStatusArray = values.employeeSituationInput.map((item) => {
        return item.value;
      });

      const valuesToSubmit = {
        starts: values.periodStarts || null,
        ends: values.periodEnds || null,
        plan_category_id: categoryPlansArray || null,
        seller_id: values.sellerInput.value || null,
        organization_id: values.organizationInput.value || null,
        unit_id: values.departmentInput.value || null,
        proposal_status_id: proposalStatusArray || null,
        cadastral_status: cadastralStatusArray || null,
      };

      toggleLoading();
      api
        .create('/reports/proposal/for-renewal', valuesToSubmit)
        .then((response) => {
          openPdfWithBase64(response.data, 'Propostas para Renovação');
        })
        .catch((error) => {
          notifyError(error.response.data.messages.error);
        })
        .finally(() => {
          setLoading(false);
        });
    },
  });

  useEffect(() => {
    if (validation.values.organizationInput.value) {
      getOptionsToDepartmentInput(validation.values.organizationInput.value);
    } else {
      setDepartmentOptions([]);
    }
  }, [getOptionsToDepartmentInput, validation.values.organizationInput]);

  useEffect(() => {
    getSellers();
    getCategoryPlans();
    getOrganizations();
    getProposalStatus();
  }, []);

  return (
    <ProposalsForRenewalPage
      history={history}
      createData={createData}
      validation={validation}
      resetDepartmentInput={resetDepartmentInput}
      // Data
      sellers={sellers || []}
      organizations={organizations || []}
      categoryPlans={categoryPlans || []}
      departmentOptions={departmentOptions || []}
      proposalStatusOptions={proposalStatusOptions}
      cadastralStatusOptions={cadastralStatusOptions}
    />
  );
};
